import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
const dotVariants = cva('inline-block h-2 w-2 shrink-0 rounded-[var(--radius-4)]', {
    variants: {
        variant: {
            green: 'bg-[var(--color-state-success-fg)]',
            amber: 'bg-[var(--color-state-warning-fg)]',
            red: 'bg-[var(--color-state-danger-fg)]',
            blue: 'bg-[var(--color-state-info-fg)]',
            slate: 'bg-[var(--color-text-muted)]',
        },
    },
    defaultVariants: { variant: 'slate' },
});
export const StatusDot = React.forwardRef(({ className, variant, ...props }, ref) => (_jsx("span", { ref: ref, role: "status", "aria-live": "polite", className: cn(dotVariants({ variant }), className), ...props })));
StatusDot.displayName = 'StatusDot';
//# sourceMappingURL=status-dot.js.map